/**
 * Exports an array of objects to a CSV file and triggers download.
 * @param data Array of objects to export
 * @param columns Column definitions: { header: string; key: string }
 * @param filename Filename without extension
 */
export function exportToCsv<T extends Record<string, any>>(
  data: T[],
  columns: { header: string; key: keyof T; format?: (value: any) => string }[],
  filename: string
): void {
  if (!data.length) return;

  const headerRow = columns.map((c) => `"${c.header}"`).join(',');

  const dataRows = data.map((row) =>
    columns
      .map((col) => {
        const value = row[col.key];
        const formatted = col.format ? col.format(value) : String(value ?? '');
        return `"${formatted.replace(/"/g, '""')}"`;
      })
      .join(',')
  );

  const csv = [headerRow, ...dataRows].join('\n');
  const bom = '\uFEFF'; // BOM for Excel UTF-8 compatibility
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

/**
 * Formats a number as Brazilian currency (R$ 1.234,56) for CSV.
 */
export function formatCurrencyCsv(value: number | undefined | null): string {
  if (value == null) return '—';
  return value.toFixed(2).replace('.', ',');
}
